export default "page-home img {\n\tmax-width: 400px;\n\theight: auto;\n\tpadding: 3rem;\n}\n";